var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabases04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.95C18 12.027 15.3137 12.9 12 12.9C8.68629 12.9 6 12.027 6 10.95M18 10.95C18 9.87304 15.3137 9 12 9C8.68629 9 6 9.87304 6 10.95M18 10.95V20.05C18 21.129 15.3333 22 12 22C8.66667 22 6 21.129 6 20.05V10.95M18 15.5C18 16.579 15.3333 17.45 12 17.45C8.66667 17.45 6 16.579 6 15.5M9 3.2C9 3.86274 7.433 4.4 5.5 4.4C3.567 4.4 2 3.86274 2 3.2M9 3.2C9 2.53726 7.433 2 5.5 2C3.567 2 2 2.53726 2 3.2M9 3.2V6M2 3.2V8.8C2 9.12113 2.36384 9.41232 2.95954 9.62742M22 3.2C22 3.86274 20.433 4.4 18.5 4.4C16.567 4.4 15 3.86274 15 3.2M22 3.2C22 2.53726 20.433 2 18.5 2C16.567 2 15 2.53726 15 3.2M22 3.2V8.8C22 9.12113 21.6362 9.41232 21.0405 9.62742M15 3.2V6",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabases04);
export default __webpack_public_path__ + "static/media/databases-04.0b67950ebd8fb02e1efd70f8991631aa.svg";
export { ForwardRef as ReactComponent };